module.exports = __webpack_public_path__ + "img/grand-prize-cn.6a01e8b.png";